'use strict';

var UserIdleConfiguration = function UserIdleConfiguration(idleProvider, keepaliveProvider, titleProvider) {
  // Consider IDLE User after 5 minutes with no activity.
  var IDLE = 300;

  // After User Become IDLE wait 25 minutes to finish the session (even if is session is valid).
  var TIMEOUT = 1440;

  // Every 30 minutes ping to API.
  var KEEP_ALIVE_INTERVAL = 1800;

  //disable default page title change
  titleProvider.enabled(false);
  idleProvider.idle(IDLE);
  idleProvider.timeout(TIMEOUT);
  idleProvider.keepalive(true);
  keepaliveProvider.http('/api/authenticateduser');
  keepaliveProvider.interval(KEEP_ALIVE_INTERVAL);
  idleProvider.windowInterrupt('focus');
};
UserIdleConfiguration.$inject = ['IdleProvider', 'KeepaliveProvider', 'TitleProvider'];
module.exports = UserIdleConfiguration;